<legend>
  <span>
    {{ 'tkey;operations.menu.title' | translate }}
  </span>
</legend>

<div class="list-group">
  <a
    id="operations-menu-transfer-user"
    data-automation="operations-menu-transfer-user"
    class="btn btn-border list-group-item"
    (click)="onReassignClick()"
    [ngClass]="{ disabled: !canReassign() }"
    [ngbTooltip]="getReassignToolTip() | translate"
  >
    <span [ngClass]="ziroIcons.REASSIGN"></span>
    <span class="operations-menu-text">
      {{ 'tkey;operations.menu.reassign.text' | translate }}
    </span>
  </a>

  <a
    id="operations-menu-transfer-public"
    data-automation="operations-menu-transfer-public"
    class="btn btn-border list-group-item"
    (click)="onMakePublicClick()"
    [hidden]="!isDeskphoneEnabledOnAnyClusters"
    [ngClass]="{ disabled: !canMakePublic() }"
    [ngbTooltip]="getMakePublicToolTip() | translate"
  >
    <span [ngClass]="ziroIcons.DESKPHONE_SMALL"></span>
    <span class="operations-menu-text">
      {{ 'tkey;operations.menu.make_public.text' | translate }}
    </span>
  </a>

  <a
    id="operations-menu-pin-reset"
    data-automation="operations-menu-pin-reset"
    class="btn btn-border list-group-item"
    (click)="onPinResetClick()"
    [ngClass]="{ disabled: !hasPinToReset() }"
    [ngbTooltip]="getPinResetTooltip() | translate"
  >
    <span [ngClass]="ziroIcons.REFRESH"></span>
    <span class="operations-menu-text">
      {{ 'tkey;operations.menu.pinreset.text' | translate }}
    </span>
  </a>

  @if (isChangeSiteEnabled()) {
    <a
      id="operations-menu-change-site"
      data-automation="operations-menu-change-site"
      class="btn btn-border list-group-item"
      (click)="onChangeSiteClick()"
      [ngClass]="{ disabled: !hasDevice() }"
      [ngbTooltip]="getChangeSiteToolTip() | translate"
    >
      <span [ngClass]="ziroIcons.SITE"></span>
      <span class="operations-menu-text">
        {{ 'tkey;operations.menu.change_site.text' | translate }}
      </span>
    </a>
  }

  @if (isSendEmailEnabled()) {
    <a
      id="operations-menu-send-email"
      data-automation="operations-menu-send-email"
      class="btn btn-border list-group-item"
      (click)="onSendEmailClick()"
    >
      <i [class]="ziroIcons.SEND_EMAIL"></i>
      <span class="operations-menu-text">
        {{ 'tkey;operations.menu.send_email.text' | translate }}
      </span>
    </a>
  }
</div>
